import { render } from "./FormContato.vue?vue&type=template&id=00009974&scoped=true"
import script from "./FormContato.vue?vue&type=script&lang=js"
export * from "./FormContato.vue?vue&type=script&lang=js"

import "./FormContato.vue?vue&type=style&index=0&id=00009974&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00009974"]])

export default __exports__